import axios from 'axios';

const Axios = axios.create({
  baseURL: window.REACT_APP_CONSENT_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
export default Axios;
